import React, { Component } from "react";
import { createPortal } from "react-dom";
import Modal from "react-animated-modal";

const CreateModal = ({ _, handleModal, redirectToBridge }) => {
  return createPortal(
    <Modal visible={true} closemodal={handleModal} type="fadeIn">
      <div className="document-modal">
        <div className="modal" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{_.ForgotPasswordModalTitle}</h5>
                <button className="close" onClick={handleModal}>
                  <i className="icon-omni-close-circle" />
                </button>
              </div>
              <div
                className="modal-body m-auto"
                style={{ textAlign: "center" }}
              >
                <div>
                  <h5>{_.RedirectedToOASISBridge}</h5>
                  <h5>{_.PleaseClickForgotPassword}</h5>
                  <br />
                  <h5>{_.ClickingContinue}</h5>
                </div>
              </div>
              <div className="react-modal-body-footer">
                <button className="btn" onClick={redirectToBridge}>
                  {_.Continue}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>,
    document.getElementById("root")
  );
};

class ForgotPassword extends Component {
  state = { isVisibleModal: false };

  handleModal = () => {
    const { isVisibleModal } = this.state;
    this.setState({ isVisibleModal: !isVisibleModal });
  };

  redirectToBridge = () => {
    const host = window.location.hostname;
    let bridgeApp = "https://testbridge.oasisgroup.com/dhsrmweb";

    if (host === "clienthub.oasisgroup.com" || host === "hub.omnidox5.com") {
      bridgeApp = "https://oasisbridge.oasisgroup.com/dhsrmweb";
    }

    const link = document.createElement("a");
    link.setAttribute("href", `${bridgeApp}`);
    link.target = "_blank";
    link.click();
    this.handleModal();
  };

  render() {
    const { _ } = this.props;
    const { isVisibleModal } = this.state;
    return (
      <>
        <div
          className="form-group forgot-password-link"
          onClick={this.handleModal}
        >
          {_.ForgotPassword}?
        </div>
        {isVisibleModal && (
          <CreateModal
            _={_}
            handleModal={this.handleModal}
            redirectToBridge={this.redirectToBridge}
          />
        )}
      </>
    );
  }
}

export default ForgotPassword;
